import React from 'react';

import { BlogBannerCta } from './blog-banner-cta';
import { BlogBofCta } from './blog-bof-cta';
import { BlogSimpleBannerCta } from './blog-simple-banner-cta';
import { BlogTofCta } from './blog-tof-cta';

type LinkType =
	| 'directoryLink'
	| 'externalLink'
	| 'internalLink'
	| 'iterablePopup'
	| 'marketoPopup';

interface BlogPostCtaProps {
	ctaAudience: string;
	ctaBrandIcon: string;
	ctaContent: string;
	ctaDescription: string;
	ctaEyebrow?: string;
	ctaHeading: string;
	ctaLinkLabel: string;
	ctaStyle: string;
	ctaType: string;
	iterablePopup?: string;
	landingPageRoute: string;
	link: string;
	linkType: LinkType;
	marketoPopup?: string;
	openInNewTab: boolean;
	route: string;
}

export function BlogPostCta({
	ctaAudience,
	ctaBrandIcon,
	ctaContent,
	ctaDescription,
	ctaEyebrow,
	ctaHeading,
	ctaLinkLabel,
	ctaStyle,
	ctaType,
	iterablePopup,
	landingPageRoute,
	link,
	linkType,
	marketoPopup,
	openInNewTab,
	route,
}: BlogPostCtaProps) {
	switch (ctaType) {
		case 'bannerCta':
			return (
				<BlogBannerCta
					ctaAudience={ctaAudience}
					ctaDescription={ctaDescription}
					ctaHeading={ctaHeading}
					ctaLinkLabel={ctaLinkLabel}
					ctaStyle={ctaStyle}
					iterablePopup={iterablePopup}
					landingPageRoute={landingPageRoute}
					link={link}
					linkType={linkType}
					marketoPopup={marketoPopup}
					openInNewTab={openInNewTab}
					route={route}
				/>
			);
		case 'bofCta':
			return (
				<BlogBofCta
					ctaAudience={ctaAudience}
					ctaBrandIcon={ctaBrandIcon}
					ctaContent={ctaContent}
					ctaHeading={ctaHeading}
					ctaLinkLabel={ctaLinkLabel}
					iterablePopup={iterablePopup}
					landingPageRoute={landingPageRoute}
					link={link}
					linkType={linkType}
					marketoPopup={marketoPopup}
					openInNewTab={openInNewTab}
					route={route}
				/>
			);
		case 'simpleBanner':
			return (
				<BlogSimpleBannerCta
					ctaAudience={ctaAudience}
					ctaLinkLabel={ctaLinkLabel}
					ctaStyle={ctaStyle}
					iterablePopup={iterablePopup}
					landingPageRoute={landingPageRoute}
					link={link}
					linkType={linkType}
					marketoPopup={marketoPopup}
					openInNewTab={openInNewTab}
					route={route}
				/>
			);
		case 'tofCta':
			return (
				<BlogTofCta
					ctaAudience={ctaAudience}
					ctaContent={ctaContent}
					ctaEyebrow={ctaEyebrow}
					ctaHeading={ctaHeading}
					ctaLinkLabel={ctaLinkLabel}
					iterablePopup={iterablePopup}
					landingPageRoute={landingPageRoute}
					link={link}
					linkType={linkType}
					marketoPopup={marketoPopup}
					openInNewTab={openInNewTab}
					route={route}
				/>
			);
		default:
			return null;
	}
}
